import React from 'react';
import { Provider } from 'react-redux';

import configureStore from '../store/offerV2ModalStore';
import OfferV2ModalContainer from '../containers/OfferV2ModalContainer';

// See documentation for https://github.com/reactjs/react-redux.
// This is how you get props from the Rails view into the redux store.
// This code here binds your smart component to the redux store.
const OfferV2ModalApp = (props) => (
  <Provider store={configureStore(props)}>
    <OfferV2ModalContainer />
  </Provider>
);

export default OfferV2ModalApp;
